// BOORO: the same task outcomes as the agent table, grouped by the model that
// finished each task. A task with several attempts counts once.
import { formatCost, formatSavedMinutes, formatSuccessRate } from "@booro/tasks";
import { Trans } from "@lingui/react/macro";
import type { DashboardModelRow } from "@rakazo/contracts";

export function ModelBreakdown({ models }: { models: readonly DashboardModelRow[] }) {
  if (models.length === 0) return null;
  return (
    <div data-testid="dashboard-models" className="mt-4 space-y-2">
      <h2 className="text-[13px] font-medium text-foreground">
        <Trans>By model</Trans>
      </h2>
      <div className="overflow-x-auto rounded-2xl border border-border bg-card">
        <table className="w-full min-w-[480px] text-[13.5px]">
          <thead>
            <tr className="border-b border-border text-start text-[12px] tracking-wider uppercase text-muted-foreground">
              <th className="px-4 py-2.5 text-start font-medium">
                <Trans>Model</Trans>
              </th>
              <th className="px-4 py-2.5 text-end font-medium">
                <Trans>Done</Trans>
              </th>
              <th className="px-4 py-2.5 text-end font-medium">
                <Trans>Success rate</Trans>
              </th>
              <th className="px-4 py-2.5 text-end font-medium">
                <Trans>Time saved</Trans>
              </th>
              <th className="px-4 py-2.5 text-end font-medium">
                <Trans>Cost</Trans>
              </th>
            </tr>
          </thead>
          <tbody>
            {models.map((model) => (
              <tr
                key={`${model.modelProvider ?? ""}::${model.modelId ?? ""}`}
                className="border-b border-border last:border-b-0"
              >
                <td className="px-4 py-2.5">
                  <span className="block truncate" dir="auto">
                    {model.modelId ?? <Trans>Unknown model</Trans>}
                  </span>
                  {model.modelProvider ? (
                    <span className="block truncate text-[11px] text-muted-foreground">
                      {model.modelProvider}
                    </span>
                  ) : null}
                </td>
                <td className="px-4 py-2.5 text-end">{model.done}</td>
                <td className="px-4 py-2.5 text-end">{formatSuccessRate(model.successRate)}</td>
                <td className="px-4 py-2.5 text-end">{formatSavedMinutes(model.minutesSaved)}</td>
                <td className="px-4 py-2.5 text-end">{formatCost(model.costUsd)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
